import React, { useState } from "react";
import { CompactPicker, BlockPicker, TwitterPicker } from 'react-color';
import UpdateProjectPhaseMutation from '../../../graphql/project-phase/mutations/UpdateProjectPhaseMutation';
import { ButtonSave, ButtonCancel } from '../../../components/Buttons';
import { Formik } from 'formik';
import * as Yup from "yup";


export default (props) => {



    const update = data => {
        UpdateProjectPhaseMutation({ ...data }, (response) => {
            if (response.status === 'OK') {
                props.doClose({
                    ...response, msgSnackbar: {
                        message: 'C bon c fait',
                        variant: 'success',
                        open: true,
                    }
                });
            } else {
                console.log({ error: 'Erreur' });
            }

        });
    }

    return (
        <Formik
            initialValues={{ id: props.data.id, name: props.data.name, color: props.data.color }}
            validationSchema={Yup.object().shape({
                name: Yup.string().required("Required"),
                color: Yup.string().required("Required")
            })}
            onSubmit={(values, { setSubmitting }) => {
                update({ id: props.data.id, ...values });
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue
                /* and other goodies */
            }) => (
                    <form onSubmit={handleSubmit} className="p-5">
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">LIBELLE:</label>
                            <div className="col-sm-8">
                                <input
                                    type="text"
                                    name="name"
                                    className={
                                        errors.name && touched.name
                                            ? "form-control form-control-sm is-invalid"
                                            : "form-control form-control-sm"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={(values.name) ? values.name : ''} />
                                {errors.name && touched.name && (
                                    <div className="invalid-feedback">{errors.name}</div>
                                )}
                            </div>

                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Coleur:</label>
                            <div className="col-sm-8">

                                <div title="#FCB900" tabIndex="0" style={{
                                    background: values.color,
                                    height: "30px",
                                    width: "100%",
                                    cursor: "pointer",
                                    position: "relative",
                                    outline: "none",
                                    float: "left",
                                    borderRadius: "4px",
                                    margin: "0px 6px 6px 0px"
                                }}></div>
                                <hr />
                                <TwitterPicker
                                    width="100%"
                                    name="color"
                                    triangle="hide"
                                    color={(values.color) ? values.color : ''}
                                    onChangeComplete={(event) => setFieldValue('color', event.hex)} />

                                {errors.color && touched.color && (
                                    <div className="invalid-feedback">{errors.color}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12 text-right">
                                <ButtonCancel onClick={() => props.doClose()}></ButtonCancel>
                                <ButtonSave onClick={() => handleSubmit()}></ButtonSave>
                            </div>
                        </div>
                    </form>

                )}
        </Formik>
    )
}

